import { Theme } from '@mui/material';
import { createUseStyles as createJssUseStyles, Styles } from 'react-jss';
import { useTheme } from '@mui/material/styles';

type StyleFunction<T> = (theme: Theme) => T;

export function createUseStyles<T extends Styles>(styles: T | StyleFunction<T>) {
  const useJssStyles = createJssUseStyles((theme: Theme) => {
    if (typeof styles === 'function') {
      return styles(theme);
    }
    return styles;
  });

  return () => {
    const theme = useTheme();
    return useJssStyles({ theme });
  };
}
